import { Component } from '@angular/core';
import { ModalController, ViewController, NavParams } from 'ionic-angular';
/**
 * Generated class for the ForbidenloginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'daily-activity',
  templateUrl: 'cmp.html'
})
export class DailyActivity {

  text: string;
  data = {
    hari : "Selasa, 20 April 2020",
    list : [],
  };
  skeleton = false;
  
  constructor(
    public viewCtrl : ViewController,
    public navParams : NavParams,
  ) {
    this.data.list = this.navParams.get("data");
    this.data.hari = this.navParams.get("hari");
  }

  tutup(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/activity_daily/cmp.ts